<!-- Modal backdrop -->
@if (devolucionDineroModalService.isOpen$ | async) {
  <div
    class="fixed inset-0 bg-black/40 z-[10000] flex items-center justify-center transition-opacity duration-300 ease-in-out overflow-y-auto py-10"
    (click)="closeModal()"
    >
    <!-- Modal container -->
    <div
      class="bg-white rounded-lg shadow-md w-11/12 sm:w-10/12 md:w-9/12 lg:w-8/12 max-w-md mx-auto z-50 overflow-hidden transform transition-all duration-300 ease-in-out"
      (click)="$event.stopPropagation()"
      >
      <!-- Header -->
      <div
        class="bg-red-500 px-4 sm:px-6 py-3 sm:py-4 border-b border-red-300 flex justify-between items-center"
        >
        <h3 class="text-lg font-semibold text-white">Pedido Rechazado</h3>
        <button
          (click)="closeModal()"
          class="text-white hover:text-red-200 transition-colors duration-200"
          >
          <svg
            class="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            ></path>
          </svg>
        </button>
      </div>
      <!-- Body -->
      <div class="p-4 sm:p-6">
        <div class="text-center mb-6">
          <div
            class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4"
            >
            <svg
              class="h-6 w-6 text-red-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
              ></path>
            </svg>
          </div>
          <h4 class="text-lg font-medium text-gray-900 mb-2">
            Lo sentimos, tu pedido no pudo ser procesado
          </h4>
          @if (orderData?.message) {
            <p class="text-sm text-gray-600 mb-4">
              Motivo: {{ orderData.message }}
            </p>
          }
          <p class="text-sm text-gray-600">
            Puedes seleccionar la devolución de tu dinero a tu método de pago
            original en un plazo de 3-5 días hábiles o en Subicoins de manera
            instantánea.
          </p>
        </div>
        <!-- Order info -->
        @if (orderData) {
          <div class="bg-gray-50 rounded-lg p-4 mb-6">
            <h5 class="font-medium text-gray-900 mb-2">Información del pedido:</h5>
            <div class="text-sm text-gray-600">
              <p>
                <span class="font-medium">Número de pedido:</span> #{{
                orderData.orderId
                }}
              </p>
              @if (orderData.userId) {
                <p>
                  <span class="font-medium">Usuario:</span> {{ orderData.userId }}
                </p>
              }
            </div>
          </div>
        }
        <!-- Actions -->
        <div class="flex flex-col sm:flex-row gap-3">
          <button
            (click)="requestRefund('subicoins')"
            class="flex-1 bg-gray-200 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-300 transition-colors duration-200 font-medium"
            >
            Créditos
          </button>
          <button
            (click)="requestRefund('card')"
            class="flex-1 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors duration-200 font-medium"
            >
            Tarjeta
          </button>
        </div>
      </div>
    </div>
  </div>
}
